// Lightweight attribution tracker for dealer application conversions.
// Captures first-touch + current-touch + UTM params.
// First-touch is stored in sessionStorage so it survives in-app navigation
// (e.g. /totalwirelessmasteragent → /become-dealer#apply).

const SS_KEY = "pmw_first_touch";

export function captureFirstTouch() {
  if (typeof window === "undefined") return;
  if (window.sessionStorage.getItem(SS_KEY)) return; // already captured this session
  const first = {
    url: window.location.href,
    pathname: window.location.pathname,
    hash: window.location.hash || "",
    search: window.location.search || "",
    referrer: document.referrer || "",
    captured_at: new Date().toISOString(),
  };
  try {
    window.sessionStorage.setItem(SS_KEY, JSON.stringify(first));
  } catch (_e) {
    // Private browsing / storage-blocked — skip silently.
  }
}

export function getSubmitSource() {
  if (typeof window === "undefined") return null;
  let first_touch = null;
  try {
    const raw = window.sessionStorage.getItem(SS_KEY);
    if (raw) first_touch = JSON.parse(raw);
  } catch (_e) { /* noop */ }

  const utm = {};
  try {
    const p = new URLSearchParams(window.location.search);
    for (const k of ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid", "fbclid"]) {
      const v = p.get(k);
      if (v) utm[k] = v;
    }
  } catch (_e) { /* noop */ }

  return {
    first_touch,
    last_touch: {
      url: window.location.href,
      pathname: window.location.pathname,
      hash: window.location.hash || "",
      search: window.location.search || "",
      referrer: document.referrer || "",
    },
    utm,
    user_agent: navigator.userAgent,
    submitted_at: new Date().toISOString(),
  };
}
